import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Inventaris from './pages/Inventaris';
import Penjualan from './pages/Penjualan';
import Pembelian from './pages/Pembelian';
import Lokasi from './pages/Lokasi';
import Pengguna from './pages/Pengguna';
import MetodePembayaran from './pages/MetodePembayaran';
import Pelanggan from './pages/Pelanggan';
import Katalog from './pages/Katalog';
import Produksi from './pages/Produksi';
import Mutasi from './pages/Mutasi';
import PesananPO from './pages/PesananPO';
import PesananKatalog from './pages/PesananKatalog';

function RequireAuth({ children }: { children: React.ReactElement }) {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/" replace />;
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public */}
          <Route path="/" element={<Login />} />
          <Route path="/katalog" element={<Katalog />} />

          {/* Protected — Layout sebagai parent route */}
          <Route
            element={
              <RequireAuth>
                <Layout />
              </RequireAuth>
            }
          >
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/inventaris" element={<Inventaris />} />
            <Route path="/penjualan" element={<Penjualan />} />
            <Route path="/pembelian" element={<Pembelian />} />
            <Route path="/lokasi" element={<Lokasi />} />
            <Route path="/pengguna" element={<Pengguna />} />
            <Route path="/metode-pembayaran" element={<MetodePembayaran />} />
            <Route path="/pelanggan" element={<Pelanggan />} />
            <Route path="/produksi" element={<Produksi />} />
            <Route path="/mutasi" element={<Mutasi />} />
            <Route path="/pesanan-po" element={<PesananPO />} />
            <Route path="/pesanan-katalog" element={<PesananKatalog />} />
          </Route>

          {/* Fallback — jangan redirect /katalog */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
